import styled from 'styled-components';
import Img from 'gatsby-image';

export const StyledIcon = styled(Img)`
  margin-right: 30px;
  z-index: -1;
`;
